export default __webpack_public_path__ + "static/sql-dark-e711a0ba56292badf6658efe65a908c0.png";